/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Replan strategy.
 */
export interface ReplanStrategyLastmile { 
    /**
     * Activate trip actions reorder.
     */
    reorder?: boolean;
    /**
     * Activate new orders planning.
     */
    plan_new_orders?: boolean;
    /**
     * Activate new trips creation.
     */
    create_new_trips?: boolean;
}

